import React from 'react';
import { Card } from '../design-system';

const CardGrid = ({ allCards, collectedCards, onCardClick }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      {allCards.map((card) => {
        const isCollected = collectedCards.includes(card.cardId);
        
        return (
          <Card
            key={card.cardId}
            variant="elevated"
            className={`
              relative cursor-pointer transition-all duration-200
              ${isCollected 
                ? 'hover:scale-105 hover:shadow-lg' 
                : 'opacity-50 grayscale'
              }
            `}
            onClick={() => onCardClick(card)}
          >
            <div className="aspect-[3/4] relative overflow-hidden rounded-lg">
              {isCollected ? (
                <>
                  {/* Collected Card - Show Image */}
                  <img
                    src={card.imageUrl}
                    alt={card.name}
                    className="w-full h-full object-cover"
                  />
                  {/* Collected Badge */}
                  <div className="absolute top-2 right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-semibold">
                    ✓
                  </div>
                </>
              ) : (
                <>
                  {/* Uncollected Card - Show Placeholder Image */}
                  <img
                    src={card.imageUrl}
                    alt={card.name}
                    className="w-full h-full object-cover"
                  />
                  {/* Lock Icon Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40">
                    <svg 
                      className="w-12 h-12 text-white" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                </>
              )}
            </div>
            
            {/* Card Name */}
            <div className="p-3 text-center">
              <h3 className={`font-semibold text-sm ${isCollected ? 'text-gray-900' : 'text-gray-400'}`}>
                {card.name}
              </h3>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default CardGrid;

